<template>
    <div class="row h-100">
        <div class="col-12 d-none d-md-block col-md-5">
            <div class="left__auth_block">
                <a class="header__logo" :href="homelink">
                    <img src="/img/logo_white.png" alt="">
                </a>
                <h2 class="mb-4">{{ get_translation_constant('text_has_account') }}</h2>
                <a class="btn btn__medium btn__black mb-4"
                   :href="loginlink">{{ get_translation_constant('text_entry_account') }}</a>
                <p>{{ get_translation_constant('text_to_place_order') }}</p>
            </div>
        </div>
        <div class="col-12 col-md-6 offset-md-1 col-lg-5 offset-lg-2">
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade " :class="active_step ? 'show active': ''" id="step_1" role="tabpanel"
                     aria-labelledby="step_1-tab">
                    <h2>{{ get_translation_constant('text_create_account') }}</h2>
                    <form @submit.prevent="register()">
                        <div class="form__col " :class="hasError('email')">
                            <label for="email">{{ get_translation_constant('text_email') }}<sup>*</sup></label>
                            <input v-model="form.email" class="form__control" id="email" name="email" type="email"
                                   :placeholder="get_translation_constant('text_entry_email')">
                            <div class="form__error" v-if="hasErrorMessage('email')">
                                {{ hasErrorMessage('email') }}
                            </div>
                        </div>
                        <div class="form__col">
                            <label for="phone">{{ get_translation_constant('text_phone') }}</label>
                            <input v-model="form.phone" class="form__control type_tel" id="phone" name="phone"
                                   type="tel" :placeholder="get_translation_constant('text_entry_phone')">
                        </div>
                        <div v-if="nodeid !=='1'" class="form__col form__address" :class="hasError('city_id')">
                            <label for="address">{{ get_translation_constant('text_your_city') }}<sup>*</sup></label>
                            <multiselect v-model="form.city_id"
                                         class="form-control"
                                         :multiple="false"
                                         :placeholder="get_translation_constant('text_choose_city')"
                                         :options="cities"
                                         label="title"
                                         selectLabel=""
                                         deselectLabel=""
                                         :optionHeight="48"
                                         :showPointer="true"

                            >
                                <template></template>
                            </multiselect>
                            <div class="form__error" v-if="hasErrorMessage('city_id')">
                                {{ hasErrorMessage('city_id') }}
                            </div>
                        </div>

                        <div v-else class="form__col"
                             :class="hasError('deliveryMethod.text_your_city')">
                            <label>{{
                                    get_translation_constant('text_your_city')
                                }}</label>
                            <multiselect v-model="form.city_ref"
                                         class="form-control"
                                         :multiple="false"
                                         :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                         :options="novaPoshtaCities"
                                         label="Description"
                                         selectLabel=""
                                         deselectLabel=""
                                         :optionHeight="48"
                                         :showPointer="true"
                                         @search-change="searchTimeOut"
                            >
                            </multiselect>
                            <div class="form__error"
                                 v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                                {{ get_translation_constant('text_field_is_required') }}
                            </div>
                        </div>

                        <div class="form__col" :class="hasError('accept_terms')">
                            <div class="checkbox__custom">
                                <input v-model="form.accept_terms" id="application_rules" name="application_rules"
                                       type="checkbox">
                                <label for="application_rules">{{ get_translation_constant('text_agree_with') }} <a
                                    :href="termslink" target="_blank">{{
                                    get_translation_constant('text_condition_services')
                                    }}</a> {{ get_translation_constant('text_and') }} <a :href="personalinfolink" target="_blank">{{
                                    get_translation_constant('text_processing_personal_information')
                                    }}</a></label>
                            </div>
                            <div class="form__error" v-if="hasErrorMessage('accept_terms')">
                                {{ hasErrorMessage('accept_terms') }}
                            </div>
                        </div>

                        <div class="form__col form__col_last">
                            <button @click.prevent="register"
                                    class="btn btn__medium btn__block btn__green signup_next_step" id="step_2_show"
                                    data-toggle="tab" href="#step_2" role="tab" aria-controls="home"
                                    aria-selected="true">{{ get_translation_constant('text_create_account') }}
                            </button>
                        </div>
                    </form>
                </div>
                <div class="tab-pane fade" :class="!active_step ? 'show active': ''" id="step_2" role="tabpanel"
                     aria-labelledby="step_2-tab">
                    <h2>{{ get_translation_constant('text_personal_data') }}</h2>
                    <p class="text_big color__gray_1">{{ get_translation_constant('text_get_free_address') }}
                        <span>{{ get_translation_constant('text_get_free_address') }}</span>,
                        {{ get_translation_constant('text_can_fill_data_in_account') }}</p>
                    <form>
                        <div class="form__col">
                            <label>{{ get_translation_constant('text_firstname_lastname_' + mainlng) }}</label>
                            <div class="row">
                                <div class="col-6" :class="hasError('first_name_latin')">
                                    <input v-model="form_user.first_name_latin" class="form__control" id="name_ro"
                                           name="name_ro" type="text"
                                           :placeholder="get_translation_constant('text_your_firstname')">

                                    <div class="form__error" v-if="hasErrorMessage('first_name_latin')">
                                        {{ hasErrorMessage('first_name_latin') }}
                                    </div>
                                </div>

                                <div class="col-6" :class="hasError('last_name_latin')">
                                    <input v-model="form_user.last_name_latin" class="form__control" id="surname_ro"
                                           name="surname_ro" type="text"
                                           :placeholder="get_translation_constant('text_your_lastname')">

                                    <div class="form__error" v-if="hasErrorMessage('last_name_latin')">
                                        {{ hasErrorMessage('last_name_latin') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form__col">
                            <label>{{ get_translation_constant('text_firstname_lastname_en') }}</label>
                            <div class="row">
                                <div class="col-6" :class="hasError('first_name')">
                                    <input v-model="form_user.first_name" class="form__control" id="name_en"
                                           name="name_en" type="text"
                                           :placeholder="get_translation_constant('text_your_firstname')">

                                    <div class="form__error" v-if="hasErrorMessage('first_name')">
                                        {{ hasErrorMessage('first_name') }}
                                    </div>
                                </div>
                                <div class="col-6" :class="hasError('last_name')">
                                    <input v-model="form_user.last_name" class="form__control" id="surname_en"
                                           name="surname_en" type="text"
                                           :placeholder="get_translation_constant('text_your_lastname')">

                                    <div class="form__error" v-if="hasErrorMessage('last_name')">
                                        {{ hasErrorMessage('last_name') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form__col">
                            <label>{{ get_translation_constant('text_sex') }}</label>
                            <div class="row no-gutters radio_group__custom">

                                <div v-for="(gender, index) in genders" class="col-auto radio_group__item">
                                    <input v-model="form_user.gender_id" :id="gender.title" name="sex" type="radio"
                                           :value="gender.id">
                                    <label :for="gender.title">{{ gender.title }}</label>
                                </div>
                                <!-- <div class="col-auto radio_group__item">
                                     <input v-model="form_user.sex" id="male" name="sex" type="radio" value="male">
                                     <label for="male">{{ get_translation_constant('text_male') }}</label>
                                 </div>
                                 <div class="col-auto radio_group__item">
                                     <input v-model="form_user.sex" id="female" name="sex" type="radio" value="female">
                                     <label for="female">{{ get_translation_constant('text_female') }}</label>
                                 </div>-->
                            </div>
                            <div class="form__error" v-if="hasErrorMessage('gender_id')">
                                {{ hasErrorMessage('gender_id') }}
                            </div>
                        </div>

                        <div class="form__col">
                            <label for="address">{{ get_translation_constant('text_your_address') }}</label>
                            <input v-model="form_user.address" class="form__control" id="address" name="address"
                                   type="text"
                                   :placeholder="get_translation_constant('text_enter_address_latin_letters')">
                            <div class="form__error">{{ get_translation_constant('text_field_is_required') }}</div>
                        </div>

                        <div class="form__col form__col_last d-flex justify-content-between align-items-center">
                            <a class="get__address" href="javascript:void(0)"
                               @click.prevent="accountAddress()">{{ get_translation_constant('text_get_address') }}</a>
                            <button class="btn btn__medium btn__green" @click.prevent="accountAccept()">
                                {{ get_translation_constant('text_accept') }}
                            </button>
                        </div>

                        <div class="form__col" :class="hasError('token')">
                            <div class="form__error" v-if="hasErrorMessage('token')">
                                Token Error!
                            </div>
                        </div>
                        <div class="form__col" :class="hasError('server')">
                            <div class="form__error" v-if="hasErrorMessage('server')">
                                Server Error!
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-12 d-md-none col-md-5 mt-5">
            <h5>{{ get_translation_constant('text_has_account') }}</h5>
            <p><a :href="loginlink">{{ get_translation_constant('text_entry_account') }}</a>, {{
                get_translation_constant('text_to_place_order') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Register",
    data() {
        return {
            errors: [],
            form: {
                locale: '',
                email: '',
                phone: '',
                accept_terms: false,
                city_id: {
                    title: '',
                    id: ''
                },
                city_ref:''
            },
            form_user: {
                locale: '',
                first_name: '',
                last_name: '',
                first_name_latin: '',
                last_name_latin: '',

                gender_id: '',
                address: '',
                token: null
            },
            accept_terms: false,
            active_step: true,
            timer: null,
            novaPoshtaCities : []
        }
    },
    props: {
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        loginlink: {
            type: [String]
        },
        redirect: {
            type: [String]
        },
        registerlink: {
            type: [String]
        },
        accoutaddresslink: {
            type: [String]
        },
        accoutacceptlink: {
            type: [String]
        },
        homelink: {
            type: [String]
        },
        accoutaddressredirectlink: {
            type: [String]
        },
        accoutacceptredirectlink: {
            type: [String]
        },
        cities: {
            type: [Object, Array]
        },
        genders: {
            type: [Object, Array]
        },
        novaposhtacitysearchlink:{
            type: [String]
        },
        nodeid : {
            type: [String, Boolean]
        },
        termslink : {
            type: [String, Boolean]
        },
        personalinfolink : {
            type: [String, Boolean]
        }

    },
    methods: {
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },


        register() {

            let data = {
                locale: this.form.locale,
                email: this.form.email,
                phone: this.form.phone,
                accept_terms: this.form.accept_terms,
            }
            //if ukraine
            if (this.nodeid ==='1'){
                data.city_ref = this.form.city_ref;
            } else{
                data.city_id = this.form.city_id.id
            }

            axios.post(this.registerlink, data).then(response => {
                if (response.status === 200) {
                    //set cookie access_token
                    this.$cookies.set('access_token', response.data['access_token'], response.data['expired_at'])
                    this.active_step = false;
                    this.form_user.token = response.data['access_token'];
                }
            }).catch(error => {
                if (error.response.status === 400) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 500) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        accountAddress() {
            window.location.replace(this.accoutaddressredirectlink);
            window.location.href = this.accoutaddressredirectlink;
        },
        accountAccept() {
            axios.post(this.accoutacceptlink, this.form_user).then(response => {

                if (response.status === 200) {
                    //set cookie access_token
                    window.location.replace(this.accoutacceptredirectlink);
                    window.location.href = this.accoutacceptredirectlink;
                }


            }).catch(error => {
                if (error.response.status === 400) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 500) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        hasError(error) {
            if (this.errors[error])
                return 'has__error';
        },

        hasErrorMessage(error) {
            if (this.errors[error])
                return this.errors[error][0];

        },

        asyncFind(query) {
            axios.post(this.novaposhtacitysearchlink, {
                find_city: query
            }).then(response => {
                this.novaPoshtaCities = response.data
            });
        },
        searchTimeOut(query) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncFind(query)
            }, 1000);
        },
    },
    computed: {},
    mounted() {
        this.form.locale = this.lng;
        this.form_user.locale = this.lng;
    }
}
</script>

<style scoped>

</style>
